export const collectionPoints = {
  Kenya: {
    collectionFee: 0,
    points: [
      
      
    ]
  },

  Nigeria: {
    collectionFee: 3,
    points: [
      {
        name: "Challenge Bookshop",
        address: "15 Broad St, Lagos Island",
        hours: "Mon–Sat, 9am–6pm"
      }
    ]
  }
};